<template>
  <div class="row">
    <div class="col">
      <div class="card">
        <!-- Card header -->
        <card-header :title="$router.currentRoute.meta.title" />
        <!-- Card body -->
        <form role="form" @submit.prevent="update">
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <div v-if="serverError" class="alert alert-danger">
                  <strong>{{ $t('labels.error') }} : </strong> {{ serverError }}
                </div>
              </div>
            </div>
            <!-- Only the fleet is editable here; the name is shown for context -->
            <div class="row" v-if="isItemFound()">
              <input-text v-model="name" :options="{ id: 'name', label: 'name', disabled: true }"/>
              <select-supplier-fleets v-model="fleet" :options="{ id: 'supplier_fleet', label: 'fleet', error: fieldErrors.fleet, placeholder: 'lists.supplier_fleet.NOT_SET' }">
                <template v-slot:hint-top>
                  <small class="text-danger">* ({{ $t('labels.required') }})</small>
                </template>
              </select-supplier-fleets>
            </div>
          </div>
          <!-- Card footer -->
          <div class="card-footer">
            <div class="row">
              <div class="col text-right">
                <router-link :to="{ name: `${routePrefix}.index`}"  class="btn btn-neutral btn-sm">
                  <i class="fa fa-arrow-left"></i>
                </router-link>
                <button v-if="isItemFound()" type="submit" class="btn btn-primary btn-sm" :disabled="loading">
                  <span v-if="loading" class="spinner-border spinner-border-sm"></span>
                  <i class="fa fa-save"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
  import { SUPPLIERS_SHOW as CRUD_ACTION_SHOW, SUPPLIERS_UPDATE as CRUD_ACTION_UPDATE } from 'actions/suppliers';
  const CRUD_CODE="suppliers";
  export default {
    name: "SupplierEdit",
    data(){
      return {
        routePrefix: CRUD_CODE,
        transPrefix: CRUD_CODE,
        id:this.$router.currentRoute.params.id,
        name: '',
        fleet: '',
        serverError: '',
        fieldErrors: {},
        responseStatus:'',
        formMode: 'edit',
        loading: false,
      }
    },
    mounted() {
      this.getItem();
    },
    methods: {
      isItemFound(){
        return this.responseStatus!==404;
      },
      getItem(){
        this.$store.dispatch(CRUD_ACTION_SHOW,{
          id: this.id,
        }).then(response=>{
          this.name=response.data.name;
          this.fleet=response.data.fleet || '';
        }).catch(error => {
          this.handleError(error);
        });
      },
      update() {
        this.fieldErrors={};
        this.serverError='';
        // The backend keeps the fleet optional on update (old suppliers have none), so require it here
        if(!this.fleet){
          this.fieldErrors={ fleet: this.$i18n.t('validation.required') };
          return;
        }
        this.loading = true;
        // PATCH is partial: only the fleet is sent, other supplier fields stay as they are
        this.$store.dispatch(CRUD_ACTION_UPDATE, {
          id: this.id,
          data: {
            fleet: this.fleet,
          },
        })
        .then(() => {
          swal({
            icon: 'success',
            text: this.$i18n.t("messages.update_successfully"),
            buttons:false,
            timer: 5000
          });
          this.$router.push({ name: `${this.routePrefix}.index` })
        })
        .catch(error => {
          this.handleError(error);
        })
      },
      handleError(error){
        this.loading = false;
        this.fieldErrors={};
        this.serverError='';

        if(error.response){
          this.responseStatus=error.response.status;
          let responseData=error.response.data;

          if(responseData.errors){
            this.fieldErrors=responseData.errors;
          }else{
            this.serverError = 'Invalid Request.'
          }
        }else{
          this.serverError = this.$i18n.t("messages.no_internet_connection");
        }

        if(this.fieldErrors.error){
          this.serverError = this.fieldErrors.error;
        }
      }
    },
  };
</script>
